(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.emotion);
    global.SplitButtonStyles = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _emotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    display: flex;\n    flex-direction: row;\n  '], ['\n    display: flex;\n    flex-direction: row;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    border-right: none !important;\n    border-radius: 3px 0px 0px 3px !important;\n  '], ['\n    border-right: none !important;\n    border-radius: 3px 0px 0px 3px !important;\n  ']);

  var SplitButtonStyles = {
    splitButton: (0, _emotion.css)(_templateObject),
    buttonPrimary: (0, _emotion.css)(_templateObject2)
  };

  exports.default = SplitButtonStyles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButton.styles.js
// module id = 1947
// module chunks = 1